// Automação "Em uma data" (event_name date_reached). Os catálogos espelham o backend
// (FazerAi::DateTriggers::Trigger): mudou lá, muda aqui.

export const DATE_REACHED_EVENT = 'date_reached';

export const DATE_TRIGGER_SUBJECTS = {
  CONTACT: 'contact',
  CONVERSATION: 'conversation',
  TASK: 'task',
};

export const DATE_TRIGGER_MODULES = {
  KANBAN: 'kanban',
  CRM: 'crm',
};

// `attributeModel`: fontes lidas de um campo personalizado do tipo data desse modelo.
// `recurring`: fontes que pedem "Repetir" (uma vez / todo ano).
export const DATE_SOURCES = [
  {
    key: 'contact_attribute',
    subject: DATE_TRIGGER_SUBJECTS.CONTACT,
    attributeModel: 'contact_attribute',
    module: null,
    recurring: true,
  },
  {
    key: 'conversation_attribute',
    subject: DATE_TRIGGER_SUBJECTS.CONVERSATION,
    attributeModel: 'conversation_attribute',
    module: null,
    recurring: true,
  },
  {
    key: 'task_attribute',
    subject: DATE_TRIGGER_SUBJECTS.TASK,
    attributeModel: 'task_attribute',
    module: DATE_TRIGGER_MODULES.KANBAN,
    recurring: true,
  },
  {
    key: 'task_due_date',
    subject: DATE_TRIGGER_SUBJECTS.TASK,
    attributeModel: null,
    module: DATE_TRIGGER_MODULES.KANBAN,
    recurring: true,
  },
  {
    key: 'task_expected_close_date',
    subject: DATE_TRIGGER_SUBJECTS.TASK,
    attributeModel: null,
    module: DATE_TRIGGER_MODULES.KANBAN,
    recurring: true,
  },
  {
    key: 'crm_occasion',
    subject: DATE_TRIGGER_SUBJECTS.CONTACT,
    attributeModel: null,
    module: DATE_TRIGGER_MODULES.CRM,
    recurring: false,
  },
  {
    key: 'crm_last_purchase',
    subject: DATE_TRIGGER_SUBJECTS.CONTACT,
    attributeModel: null,
    module: DATE_TRIGGER_MODULES.CRM,
    recurring: false,
  },
  {
    key: 'calendar_date',
    subject: DATE_TRIGGER_SUBJECTS.CONTACT,
    attributeModel: null,
    module: DATE_TRIGGER_MODULES.CRM,
    recurring: false,
  },
];

export const SUBJECT_BY_SOURCE = Object.fromEntries(
  DATE_SOURCES.map(source => [source.key, source.subject])
);

export const ACTIONS_BY_SUBJECT = {
  [DATE_TRIGGER_SUBJECTS.TASK]: [
    'add_label_to_task',
    'remove_label_from_task',
    'move_to_step',
    'mark_completed',
    'mark_cancelled',
    'assign_agent',
    'change_task_priority',
    'set_due_date',
    'set_start_date',
    'set_custom_attribute',
    'transfer_to_board',
    'send_webhook_event',
    'send_message',
    'create_scheduled_message',
    'add_private_note',
    'mute_conversation',
    'snooze_conversation',
    'resolve_conversation',
    'open_conversation',
    'assign_team',
  ],
  [DATE_TRIGGER_SUBJECTS.CONVERSATION]: [
    'add_label',
    'remove_label',
    'assign_agent',
    'assign_team',
    'remove_assigned_agent',
    'remove_assigned_team',
    'add_private_note',
    'send_message',
    'create_scheduled_message',
    'send_attachment',
    'change_status',
    'resolve_conversation',
    'open_conversation',
    'pending_conversation',
    'snooze_conversation',
    'mute_conversation',
    'change_priority',
    'send_webhook_event',
    'send_email_to_team',
    'send_email_transcript',
  ],
  [DATE_TRIGGER_SUBJECTS.CONTACT]: [
    'add_contact_label',
    'remove_contact_label',
    'send_webhook_event',
    'send_whatsapp_offer',
    'add_label',
    'remove_label',
    'assign_agent',
    'assign_team',
    'add_private_note',
    'send_message',
    'create_scheduled_message',
    'resolve_conversation',
    'open_conversation',
    'snooze_conversation',
  ],
};

// Sem fonte escolhida ainda, o seletor de ações mostra a união dos catálogos.
export const ALL_DATE_TRIGGER_ACTIONS = [
  ...new Set(Object.values(ACTIONS_BY_SUBJECT).flat()),
];

// Ações que só existem na automação por data (alvo contato).
export const DATE_ONLY_ACTIONS = [
  'add_contact_label',
  'remove_contact_label',
  'send_whatsapp_offer',
];

// Puladas para quem pediu SAIR.
export const MESSAGE_ACTIONS = [
  'send_message',
  'create_scheduled_message',
  'send_attachment',
  'send_whatsapp_offer',
];

// Catálogo de condições usado por alvo; contato não tem condições.
export const CONDITION_EVENT_BY_SUBJECT = {
  [DATE_TRIGGER_SUBJECTS.CONVERSATION]: 'conversation_updated',
  [DATE_TRIGGER_SUBJECTS.TASK]: 'kanban_task_overdue',
  [DATE_TRIGGER_SUBJECTS.CONTACT]: null,
};

export const OFFSET_MODES = {
  BEFORE: 'before',
  ON_DAY: 'on_day',
  AFTER: 'after',
  // Só em crm_occasion: usa a antecedência cadastrada em cada data (offset_days null).
  LEAD_DAYS: 'lead_days',
};

export const CRM_OCCASION_SOURCE = 'crm_occasion';
export const CALENDAR_DATE_SOURCE = 'calendar_date';

// Tipos de "Datas do cliente" (FazerAi::Crm::Campaign::OCCASION_TYPE_FILTERS sem seasonal).
export const OCCASION_TYPES = [
  'birthday',
  'anniversary',
  // Só vem de campanhas antigas convertidas; continua no seletor para a edição não ficar crua.
  'seasonal',
  'interval',
  'custom',
  'any',
];
export const DEFAULT_OCCASION_TYPE = OCCASION_TYPES[0];

// FazerAi::Crm::CommemorativeDates::KEYS; o rótulo vem de CRM_RECOMPRA.DATES.
export const COMMEMORATIVE_KEYS = [
  'dia_das_maes',
  'dia_dos_namorados',
  'dia_dos_pais',
  'dia_das_criancas',
  'black_friday',
  'natal',
  'pascoa',
  'dia_da_mulher',
  'dia_do_consumidor',
  'dia_dos_avos',
  'dia_do_cliente',
];
// "Outra data (dia e mês)": commemorative_key null com calendar_month/calendar_day.
export const CUSTOM_CALENDAR_DATE = 'custom';

export const MONTHS = Array.from({ length: 12 }, (_, index) => index + 1);
export const MAX_CALENDAR_DAY = 31;

export const MIN_PAST_BUYERS_WINDOW_DAYS = 1;
export const MAX_PAST_BUYERS_WINDOW_DAYS = 120;
export const DEFAULT_PAST_BUYERS_WINDOW_DAYS = 15;

// Campos que só valem numa fonte; nas demais vão null (o backend recusa).
const SOURCE_ONLY_FIELDS = {
  [CRM_OCCASION_SOURCE]: ['occasion_type', 'occasion_recurrence_mode'],
  [CALENDAR_DATE_SOURCE]: [
    'commemorative_key',
    'calendar_month',
    'calendar_day',
    'past_buyers_window_days',
  ],
};

export const OFFER_ACTION = 'send_whatsapp_offer';
export const OFFER_MESSAGE_MODES = { TEXT: 'text', TEMPLATE: 'template' };
export const OFFER_MAX_LENGTH = 4096;

// Mesma regra da barra lateral para a tela Clientes.
export const isCrmModuleEnabled = account =>
  account?.settings?.crm_enabled === true;

// Deslocamento em dias (não é o N 1–998 dos operadores next_days/last_days).
export const MIN_OFFSET_DAYS = 1;
export const MAX_OFFSET_DAYS = 365;

export const RECURRENCES = ['once', 'yearly'];

export const RUN_HOURS = Array.from({ length: 24 }, (_, hour) => hour);
export const DEFAULT_RUN_HOUR = 8;

export const MAX_TARGETS_PER_RUN = 5000;

// Campos aceitos em date_trigger_attributes (data-model.md §1).
export const DATE_TRIGGER_ATTRIBUTE_KEYS = [
  'source_type',
  'attribute_key',
  'occasion_type',
  'occasion_recurrence_mode',
  'commemorative_key',
  'calendar_month',
  'calendar_day',
  'offset_days',
  'recurrence',
  'run_hour',
  'audience_label_ids',
  'custom_filter_id',
  'past_buyers_window_days',
];

export const findDateSource = sourceType =>
  DATE_SOURCES.find(source => source.key === sourceType);

export const isRecurringSource = sourceType =>
  Boolean(findDateSource(sourceType)?.recurring);

export const isAttributeSource = sourceType =>
  Boolean(findDateSource(sourceType)?.attributeModel);

export const buildDefaultDateTrigger = () => ({
  source_type: null,
  attribute_key: null,
  occasion_type: null,
  occasion_recurrence_mode: null,
  commemorative_key: null,
  calendar_month: null,
  calendar_day: null,
  offset_days: 0,
  recurrence: RECURRENCES[0],
  run_hour: DEFAULT_RUN_HOUR,
  audience_label_ids: [],
  custom_filter_id: null,
  past_buyers_window_days: null,
});

export const offsetModeFor = offsetDays => {
  if (offsetDays < 0) return OFFSET_MODES.BEFORE;
  if (offsetDays > 0) return OFFSET_MODES.AFTER;
  return OFFSET_MODES.ON_DAY;
};

// null quando N falta ou sai de 1..365: a validação do formulário barra o salvamento.
export const offsetDaysFor = (mode, days) => {
  if (mode === OFFSET_MODES.ON_DAY) return 0;
  if (mode === OFFSET_MODES.LEAD_DAYS) return null;
  if (
    !Number.isInteger(days) ||
    days < MIN_OFFSET_DAYS ||
    days > MAX_OFFSET_DAYS
  ) {
    return null;
  }
  return mode === OFFSET_MODES.BEFORE ? -days : days;
};

export const buildDateTriggerAttributes = dateTrigger => {
  const attributes = Object.fromEntries(
    DATE_TRIGGER_ATTRIBUTE_KEYS.map(key => [key, dateTrigger?.[key] ?? null])
  );
  attributes.audience_label_ids = [
    ...new Set(
      (dateTrigger?.audience_label_ids || [])
        .map(Number)
        .filter(Number.isInteger)
    ),
  ];
  // Repetir só existe nas fontes de campo e de tarefa; o backend recusa nas demais.
  if (!isRecurringSource(attributes.source_type)) attributes.recurrence = null;
  if (!isAttributeSource(attributes.source_type))
    attributes.attribute_key = null;
  Object.entries(SOURCE_ONLY_FIELDS).forEach(([sourceType, fields]) => {
    if (attributes.source_type === sourceType) return;
    fields.forEach(field => {
      attributes[field] = null;
    });
  });
  return attributes;
};

const isIntegerBetween = (value, min, max) =>
  Number.isInteger(value) && value >= min && value <= max;

// Espelha o 422 do backend para o que esta tela já permite configurar.
export const validateDateTrigger = dateTrigger => {
  const errors = {};
  const sourceType = dateTrigger?.source_type;
  if (!findDateSource(sourceType)) {
    errors.date_source = true;
    return errors;
  }
  if (isAttributeSource(sourceType) && !dateTrigger.attribute_key) {
    errors.date_source = true;
  }
  // offset_mode é só da tela (não vai no payload); automação salva sem ele e com offset null
  // em crm_occasion é "antecedência de cada data".
  const usesLeadDays =
    sourceType === CRM_OCCASION_SOURCE &&
    (dateTrigger.offset_mode ?? OFFSET_MODES.LEAD_DAYS) ===
      OFFSET_MODES.LEAD_DAYS;
  if (!Number.isInteger(dateTrigger.offset_days) && !usesLeadDays) {
    errors.date_offset = true;
  }
  if (sourceType === CRM_OCCASION_SOURCE && !dateTrigger.occasion_type) {
    errors.date_occasion = true;
  }
  if (sourceType === CALENDAR_DATE_SOURCE) {
    const hasCustomDate =
      isIntegerBetween(dateTrigger.calendar_month, 1, MONTHS.length) &&
      isIntegerBetween(dateTrigger.calendar_day, 1, MAX_CALENDAR_DAY);
    if (!dateTrigger.commemorative_key && !hasCustomDate) {
      errors.date_calendar = true;
    }
    const windowDays = dateTrigger.past_buyers_window_days;
    if (
      windowDays !== null &&
      windowDays !== undefined &&
      !isIntegerBetween(
        windowDays,
        MIN_PAST_BUYERS_WINDOW_DAYS,
        MAX_PAST_BUYERS_WINDOW_DAYS
      )
    ) {
      errors.date_window = true;
    }
  }
  return errors;
};

// Espelha o 422 da oferta: caixa sempre; texto no modo text; modelo no modo template.
export const isOfferParamsValid = actionParams => {
  const params = actionParams?.[0];
  if (!params?.inbox_id) return false;
  if (params.message_mode === OFFER_MESSAGE_MODES.TEMPLATE) {
    return Boolean(params.template_name);
  }
  return Boolean(params.content?.trim());
};

// Motivos de "pulado" da simulação e do histórico (FazerAi::DateTriggers::Execution::SKIP_REASONS).
export const SKIP_REASONS = [
  'already_executed',
  'outside_audience',
  'conditions_not_met',
  'opted_out',
  'no_consent',
  'no_phone',
  'no_conversation',
  'offer_already_sent_today',
];

export const SIMULATION_STATUS_WOULD_EXECUTE = 'would_execute';

export const RUN_TRIGGER_MANUAL = 'manual';
export const RUN_STATUS_RUNNING = 'running';
export const RUN_STATUS_BLOCKED_LIMIT = 'blocked_limit';
// Runs que não executaram nada: a lista mostra alerta em vez da contagem.
export const RUN_ALERT_STATUSES = ['failed', RUN_STATUS_BLOCKED_LIMIT];

export const EXECUTION_STATUS_FILTERS = ['executed', 'skipped', 'failed'];

export const RUNS_PER_PAGE = 25;
export const EXECUTIONS_PER_PAGE = 50;

// Datas de calendário ("2026-10-12") lidas em UTC para nenhum fuso trocar o dia.
export const formatCalendarDate = (isoDate, locale, { withYear = true } = {}) =>
  new Intl.DateTimeFormat(locale.replace('_', '-'), {
    day: '2-digit',
    month: '2-digit',
    ...(withYear ? { year: 'numeric' } : {}),
    timeZone: 'UTC',
  }).format(new Date(`${isoDate}T00:00:00Z`));

// Código do motivo de um run que não executou (blocked_limit sem código = limite).
export const runErrorCode = run =>
  run.error_code ||
  (run.status === RUN_STATUS_BLOCKED_LIMIT ? 'limit_exceeded' : 'unexpected');

// Corpo do simulate para uma automação já salva (formato da API, não do formulário).
export const buildSavedRuleSimulationPayload = rule => ({
  automation_rule_id: rule.id,
  name: rule.name,
  description: rule.description,
  event_name: rule.event_name,
  conditions: rule.conditions,
  actions: rule.actions,
  date_trigger_attributes: buildDateTriggerAttributes(rule.date_trigger),
});

// 422 do controller de automações: { message, attributes } ou { error }. O message pode vir como
// texto ou como { campo: [mensagens] }; nunca se mostra o JSON.
export const apiErrorMessage = error => {
  const message =
    error?.response?.data?.message || error?.response?.data?.error || null;
  if (message && typeof message === 'object') {
    return Object.values(message).flat().join(' ');
  }
  return message;
};

export const TEMPLATE_RUN_HOUR = 6;
export const TEMPLATE_OFFSET_DAYS_BEFORE = -7;
export const TEMPLATE_REPURCHASE_OFFSET_DAYS = 30;

// Modelos prontos (a antiga Recompra): o gatilho e a oferta sem canal; o formulário só salva
// depois de escolher a caixa e a mensagem. O nome vem de AUTOMATION.DATE_TRIGGER.TEMPLATES.<KEY>.
export const DATE_TRIGGER_TEMPLATES = [
  {
    key: 'birthday',
    icon: 'i-lucide-cake',
    dateTrigger: {
      source_type: CRM_OCCASION_SOURCE,
      occasion_type: 'birthday',
      offset_days: TEMPLATE_OFFSET_DAYS_BEFORE,
    },
  },
  {
    key: 'commemorative',
    icon: 'i-lucide-calendar-heart',
    dateTrigger: {
      source_type: CALENDAR_DATE_SOURCE,
      commemorative_key: COMMEMORATIVE_KEYS[0],
      offset_days: TEMPLATE_OFFSET_DAYS_BEFORE,
    },
  },
  {
    key: 'repurchase_cycle',
    icon: 'i-lucide-repeat',
    dateTrigger: {
      source_type: 'crm_last_purchase',
      offset_days: TEMPLATE_REPURCHASE_OFFSET_DAYS,
    },
  },
];

export const findDateTriggerTemplate = key =>
  DATE_TRIGGER_TEMPLATES.find(template => template.key === key);

// date_trigger e ações de uma automação nova a partir do modelo.
export const buildDateTriggerTemplate = key => {
  const template = findDateTriggerTemplate(key);
  return {
    date_trigger: {
      ...buildDefaultDateTrigger(),
      recurrence: null,
      run_hour: TEMPLATE_RUN_HOUR,
      ...template.dateTrigger,
    },
    actions: [
      {
        action_name: OFFER_ACTION,
        action_params: [
          {
            inbox_id: null,
            message_mode: OFFER_MESSAGE_MODES.TEXT,
            content: '',
            template_name: null,
            template_params: {},
          },
        ],
      },
    ],
  };
};

// Campanha antiga não migrada → modelo equivalente.
export const templateKeyForCampaign = campaign => {
  if (campaign.recurrence_mode === 'seasonal_calendar') return 'commemorative';
  if (
    campaign.occasion_type === 'interval' ||
    campaign.recurrence_mode === 'interval'
  ) {
    return 'repurchase_cycle';
  }
  return 'birthday';
};
